/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MatchingConfigurationFromJSON, MatchingConfigurationToJSON, } from './MatchingConfiguration.js';
/**
 * Check if a given object implements the GetCompanyMatchingConfigurationResult interface.
 */
export function instanceOfGetCompanyMatchingConfigurationResult(value) {
    return true;
}
export function GetCompanyMatchingConfigurationResultFromJSON(json) {
    return GetCompanyMatchingConfigurationResultFromJSONTyped(json, false);
}
export function GetCompanyMatchingConfigurationResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matchingConfiguration': json['matchingConfiguration'] == null ? undefined : MatchingConfigurationFromJSON(json['matchingConfiguration']),
    };
}
export function GetCompanyMatchingConfigurationResultToJSON(json) {
    return GetCompanyMatchingConfigurationResultToJSONTyped(json, false);
}
export function GetCompanyMatchingConfigurationResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matchingConfiguration': MatchingConfigurationToJSON(value['matchingConfiguration']),
    };
}
